import { ShiftDifferentialType } from '~/types/hlx/enums';

export const SHIFT_DIFF_TYPE_OPTIONS = [
  { label: 'Fixed Amount ($/hour)', value: ShiftDifferentialType.INCR_HOURLY_RATE },
  { label: 'Multiplier (x Base Rate)', value: ShiftDifferentialType.MULTIPLIER },
];

export const emptyShiftDetailsForm = {
  // Shift Allocation
  numDayShifts: 0,
  numEveShifts: 0,
  numNightShifts: 0,
  numOfWeDayShifts: 0,
  numOfWeEveShifts: 0,
  numOfWeNightShifts: 0,
  numHolDayShifts: 0,
  numHolEveShifts: 0,
  numHolNightShifts: 0,
  // Shift Differentials
  shiftDiffType: SHIFT_DIFF_TYPE_OPTIONS[0],
  eveShiftRateDiff: 0,
  nightShiftRateDiff: 0,
  weDayShiftRateDiff: 0,
  weEveShiftRateDiff: 0,
  weNightShiftRateDiff: 0,
  holDayShiftRateDiff: 0,
  holEveShiftRateDiff: 0,
  holNightShiftRateDiff: 0,
};

export const emptyCallShiftDetailsForm = {
  numDayCallShifts: 0,
  numEveCallShifts: 0,
  numNightCallShifts: 0,
  numOfWeDayCallShifts: 0,
  numOfWeEveCallShifts: 0,
  numOfWeNightCallShifts: 0,
  numHolDayCallShifts: 0,
  numHolEveCallShifts: 0,
  numHolNightCallShifts: 0,
  // Shift Differentials
  callShiftDiffType: SHIFT_DIFF_TYPE_OPTIONS[0],
  dayCallShiftRateDiff: 0,
  eveCallShiftRateDiff: 0,
  nightCallShiftRateDiff: 0,
  weDayCallShiftRateDiff: 0,
  weEveCallShiftRateDiff: 0,
  weNightCallShiftRateDiff: 0,
  holDayCallShiftRateDiff: 0,
  holEveCallShiftRateDiff: 0,
  holNightCallShiftRateDiff: 0,
};
